import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
// import featherDownlaodImg from '../assets/images/Icon feather-download.png';
// import featherPlusImg from '../assets/images/Icon feather-plus.png';
import PlusIMgDark from '../assets/images/plusDark.png';
import downloadDark from '../assets/images/downloadDark.png';
//import copyImg from '../assets/images/Icon material-content-copy.png';
import copyDarkImg from '../assets/images/copyDark.png';
import Pagination from '../components/GroupInfo/Pagination';
import AddSheetFormModal from '../components/Settings/SheetSettings/AddSheetFormModal';
import SheetList from '../components/Settings/SheetSettings/SheetList';
import Toaster from '../components/Toaster';
import { getSheetSettings } from '../redux/actions/sheetSettings';
import Loader from '../components/Loader';
import { sampleCSVdownload } from '../services/extraServices';
import { sheetTemplateUrl } from '../config/index.js';
import { toast } from 'react-toastify';

const SheetSettings = () => {
  const [sheetTab, setSheetTab] = useState('data');
  const [curpage, setCurpage] = useState(1);

  const [openSheetModal, setOpenSheetModal] = useState(false);
  const sheetSettings = useSelector((state) => state.sheetSettings);
  const { loading, sheets, page, totalPage, successDelete, success } =
    sheetSettings;

  const dispatch = useDispatch();
  useEffect(() => {
    let type = sheetTab === 'data' ? 'export' : 'preApprove';
    dispatch(getSheetSettings(curpage, type));
    toast.success('opop');
  }, [dispatch, curpage, sheetTab]);

  useEffect(() => {
    let type = sheetTab === 'data' ? 'export' : 'preApprove';
    if (successDelete || success) dispatch(getSheetSettings(curpage, type));
  }, [successDelete, success, dispatch, sheetTab, curpage]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className='container googleSheetSettings customiziedWrapers'>
          {/* Modal Overlay Sectionis activate by Toogling the className activated. */}
          <div
            className={`overlayMain ${openSheetModal ? 'activate' : ''}`}
          ></div>
          {sheets && sheets.length > 0 && (
          <div className='btnBoxWraper shetSettingsBtnWraper'>
            <div className='actionBttons'>
              <button
                className='firstBtn gmNewBtn tabBtns'
                onClick={() => setOpenSheetModal(true)}
              >
                <img src={PlusIMgDark} className='tabBtnImgs' alt='' /> Add
                Sheet
              </button>
              {sheetTab === 'data' && (
                <button
                  className='secondBtn gmNewBtn tabBtns'
                  onClick={() => sampleCSVdownload()}
                >
                  <img src={downloadDark} className='tabBtnImgs' alt='' />{' '}
                  Download Sample CSV
                </button>
              )}
              {sheetTab === 'preApproved' && (
                <button
                  className='secondBtn gmNewBtn tabBtns'
                  onClick={(e) => {
                    e.preventDefault();
                    window.open(sheetTemplateUrl, '_blank');
                  }}
                >
                  <img src={copyDarkImg} className='tabBtnImgs' alt='' /> Copy
                  Template
                </button>
              )}
            </div>
          </div>
          )}
          <ul className='tabs'>
            {/* Toggle the className current to display the respective tab contents */}
            <li
              className={`tab-link ${sheetTab === 'data' ? 'current' : ''}`}
              data-tab='tab-1'
              onClick={() => {
                setSheetTab('data');
                setCurpage(1);
              }}
            >
              Data Export
            </li>
            <li
              className={`tab-link ${
                sheetTab === 'preApproved' ? 'current' : ''
              }`}
              data-tab='tab-2'
              onClick={() => {
                setSheetTab('preApproved');
                setCurpage(1);
              }}
            >
              Pre-approved
            </li>
          </ul>
          <SheetList allSheets={sheets} setOpenSheetModal={setOpenSheetModal} sampleCSVdownload={sampleCSVdownload} type={sheetTab} />
          <AddSheetFormModal
            setOpenSheetModal={setOpenSheetModal}
            openSheetModal={openSheetModal}
            type={sheetTab}
          />
          <Pagination
            setCurpage={setCurpage}
            totalPage={totalPage}
            page={page}
          />
          <Toaster />
        </div>
      )}
    </>
  );
};

export default SheetSettings;
